export interface ITipoDocumento {
    id?: number;
    descricao?: string | null;
    linkAutenticacao?: string | null;
    descricaoLink?: string | null;
    textoModelo?: string | null;
  }

  export class TipoDocumento implements ITipoDocumento {
    constructor(
      public id?: number,
      public descricao?: string | null,
      public linkAutenticacao?: string | null,
      public descricaoLink?: string | null,
      public textoModelo?: string | null
    ) {}
  }

  export function getTipoDocumentoIdentifier(tipoDocumento: ITipoDocumento): number | undefined {
    return tipoDocumento.id;
  }
